// Client-side SEO injection — keeps meta in sync during in-app navigation.
// (Crawlers get the server-injected HTML from the /blog route on the backend.)

const upsertMeta = (attr, key, content) => {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const upsertCanonical = (href) => {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

const JSONLD_CLASS = "seo-jsonld";

const clearJsonLd = () => {
  document.head
    .querySelectorAll(`script.${JSONLD_CLASS}`)
    .forEach((s) => s.remove());
};

export const applySeo = ({ title, description, keywords, canonical, jsonLd = [] }) => {
  if (title) document.title = title;
  upsertMeta("name", "description", description);
  upsertMeta("name", "keywords", keywords);
  if (canonical) upsertCanonical(canonical);

  clearJsonLd();
  jsonLd.forEach((obj) => {
    const s = document.createElement("script");
    s.type = "application/ld+json";
    s.className = JSONLD_CLASS;
    s.text = JSON.stringify(obj);
    document.head.appendChild(s);
  });
};

export const resetSeo = () => {
  document.title = "SkillYer — Learn Smart";
  clearJsonLd();
};
